import React from "react";
import { Table } from "antd";
import ObservationUnitRange from "./ObservationUnitRange";

export default function ObservationShow({ observation }) {
  return (
    <Table
      rowKey="id"
      pagination={false}
      dataSource={observation.results}
      columns={[
        {
          title: "Análisis",
          dataIndex: "name",
        },
        {
          title: "Resultados",
          dataIndex: "value",
        },
        {
          title: "Rango de Referencia",
          render: (text, item) => <ObservationUnitRange id={item.id} />,
        },
      ]}
    />
  );
}
